import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';

import { FetchCatalogAdResponse } from './catalogAd.types';

/**
 * @category Item API
 * @see fetchCatalogAd
 */

/**
 * @category Item API
 * @see fetchCatalogAd
 */
type FetchCatalogAdParams = {
    categoryIds: any;
    deployment: string;
    force?: boolean;
    keywords: any;
    pageName: any;
};

/**
 * POST request to item-api service that sends categoryIds, keywords and pageName and returns advertisement data
 * @function fetchCatalogAd
 * @category Item API
 * @param {FetchCatalogAdParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/ads/page
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/react-site/routes/get-spa-ad-units.ts
 */
export const fetchCatalogAd = ({ categoryIds, deployment, force, keywords, pageName }: FetchCatalogAdParams) =>
    new Promise<FetchCatalogAdResponse>((resolve, reject) => {
        const queryParams: Record<string, any> = {
            categoryIds,
            keywords,
            pageName,
        };

        if (force) {
            queryParams.bustCache = Date.now();
        }

        const request = makeGet({
            apiPath: 'spa/ads/page',
            deployment,
            path: ApiHosts.ItemApi,
            queryParams,
        });
        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });
